import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { t } from '@sm/intl';
import { createURL } from '@sm/utils';
import { NavRouteParams } from '~pricing/components/Navigation/types';

import BackToSummary from '~pricing/components/BackToSummary';
import MainHeading from '~pricing/components/MainHeading';
import Navigation from '~pricing/components/Navigation';
import DetailsFooter from '~pricing/components/PricingFooter';
import useTrackingDetails from '~pricing/hooks/useTrackingDetails';
import COPY from '~app/pages/Pricing/copy';
import DetailsPackagesView from '~pricing/components/DetailsPackagesView';
import { usePackages } from '~shared/hooks/usePackages';
/**
 *  This only gets generated on the details page, if canonical path is missing then,
 *  we must be on the /pricing/details (canonical to details), the back link should default to teams summary
 *  with ut_source attached as per legacy billweb
 */

export default function PricingDetailsPage(): JSX.Element {
  const { canonicalPath } = useParams<NavRouteParams>();
  const { displayPackages, allPackages } = usePackages();
  const { pageUtSource } = useTrackingDetails();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div key="PricingDetails">
      <header>
        <BackToSummary url={createURL(`/pricing/${canonicalPath || 'teams'}`, { ut_source: pageUtSource })} />
        <MainHeading>{t(COPY.DETAILS_HEADING)}</MainHeading>
        <Navigation />
      </header>
      <DetailsPackagesView packageData={displayPackages} />
      <DetailsFooter packages={allPackages} />
    </div>
  );
}
